/**
 * Main App Component - FBCA Architecture
 * Feature-Based Component Architecture with auto-discovery routing
 */

import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@voilajsx/uikit/theme-provider';
import { PageRouter } from './lib/page-router';

function App() {
  return (
    <ThemeProvider theme="default" mode="light">
      <Router basename="/uikit">
        <PageRouter />
      </Router>
    </ThemeProvider>
  );
}

export default App;